import { SettingConst } from '@faire/web-api--source/types';

/**
 * How stale the hCaptcha token can be before we refetch it on the frontend.
 */
export const HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS =
  'HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS' as SettingConst<
    'HCAPTCHA_TOKEN_MAX_STALENESS_SECONDS',
    number,
    'RETAILER' | 'VISITOR_WEB'
  >;
